/**
 * Parse a one-path-per-line textarea value into the array the runner's areas
 * endpoints expect. `null` means "clear directory mode" — an endpoint-level
 * distinction the callers must preserve, not an empty array.
 *
 * Shared with the Areas section (customer-editable directory list).
 */
export function parseShardDirectories(value: string): string[] | null {
  const directories = value
    .split('\n')
    .map((directory) => directory.trim())
    .filter(Boolean);
  return directories.length > 0 ? directories : null;
}
